module.exports = __webpack_public_path__ + "static/portfolio-img1-482c1c016dc3f8f5ef83073d77bde27e.jpg";